/**
toType(object)
Returns `typeof object`.
*/

export default (object) => typeof object;
